export default [
  "Machete",
  "Radiation",
  "Punch",
  "Dumbbell",
  "Liquid Drug",
  "Box Cutter",
  "Pistol",
  "Locked Room",
  "Blood loss",
  "Dismember",
  "Plastic Bag",
  "Wrench",
  "Amoeba",
  "Dirty Water",
  "Sniper",
  "Brick",
  "Hammer",
  "Bite and Tear",
  "Trophy",
  "E-Bike",
  "Venomous Snake",
  "Metal Chain",
  "Potted Plant",
  "Packing Tape",
  "Rope",
  "Electric Current",
  "Metal Wire",
  "Starvation",
  "Arson",
  "Plague",
  "Smoke",
  "Cleaver",
  "Electric Baton",
  "Axe",
  "Trowel",
  "Explosives",
  "Video Game Console",
  "Hook",
  "Gunpowder",
  "Venomous Scorpion",
  "Ice Skates",
  "Bury",
  "Knife and Fork",
  "Injection",
  "Wire",
  "Chainsaw",
  "Whip",
  "Poisonous Needle",
  "Unarmed",
  "Scarf",
  "Surgery",
  "Sculpture",
  "Stone",
  "Kick",
  "Arsenic",
  "Poisonous Gas",
  "Drown",
  "Powder Drug",
  "Pesticide",
  "Pill",
  "Chemicals",
  "Throat Slit",
  "Bat",
  "Sulfuric Acid",
  "Folding Chair",
  "Push",
  "Blender",
  "Pillow",
  "Alcohol",
  "Overdose",
  "Steel Tube",
  "Scissors",
  "Candlestick",
  "Machine",
  "Mad Dog",
  "Virus",
  "Dagger",
  "Lighter",
  "Razor Blade",
  "Towel",
  "Belt",
  "Wine",
  "Kerosene",
  "Mercury",
  "Drill",
  "Bamboo Tip",
  "Crutch",
  "Illegal Drug"
];
